export default __webpack_public_path__ + "static/media/Memphis_logo.e8d6a704.png";